import { EventScoreboard, PairGameScore } from '@frontend/sports/betting-offer/feature/model';

import { ScoreboardPairGameViewModel } from './pair-game-scoreboard.viewmodel';
import { PairGameScoreboardStats, ScoreboardStat } from './scoreboard-stats';

export class PairScoreboardViewModel extends ScoreboardPairGameViewModel {
    stats: PairGameScoreboardStats;

    constructor() {
        super();
        this.stats = new PairGameScoreboardStats();
    }

    private __fillStats(scoreboard: EventScoreboard): void {
        const score = scoreboard.getScore<PairGameScore>();
        if (score) {
            this.stats.addStat(new ScoreboardStat(this.scoreKey, score.participant1, score.participant2, 0, true, '', 'bold'));
        } else {
            const stat = new ScoreboardStat(this.scoreKey, 0, 0, 0, true, '', 'bold');
            stat.isEnabled = false;
            this.stats.addStat(stat);
        }
    }

    private __updateStats(scoreboard: EventScoreboard): void {
        const score = scoreboard.getScore<PairGameScore>();
        if (score) {
            this.stats.updateStatValue(this.scoreKey, { player1: score.participant1, player2: score.participant2, isVisible: true });
        } else {
            this.stats.updateStatValue(this.scoreKey, { isVisible: false });
        }
    }

    protected override fillFromScoreboard(scoreboard: EventScoreboard): void {
        super.fillFromScoreboard(scoreboard);
        this.__fillStats(scoreboard);
    }

    override updateFromScoreboard(scoreboard: EventScoreboard): void {
        super.updateFromScoreboard(scoreboard);
        this.__updateStats(scoreboard);
    }

    get score(): ScoreboardStat {
        return this.stats.values[this.scoreKey];
    }
}
